import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function moduloValidator(divisor: number, expectedRemainder: number): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = +control.value;

		if (value === null || value === undefined) {
			return null;
		}

		if (isNaN(value)) {
			return { notANumber: true }; // Handle non-number inputs
		}

		if (value % divisor !== expectedRemainder) {
			return {
				moduloMismatch: {
					actual: value % divisor,
					expected: expectedRemainder,
					divisor: divisor,
				},
			};
		}

		return null; // Valid if the modulo operation matches
	};
}
